import { render, staticRenderFns } from "./Bouwmaterialen.vue?vue&type=template&id=fbd81f16"
import script from "./Bouwmaterialen.vue?vue&type=script&lang=js"
export * from "./Bouwmaterialen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports